module.exports = __webpack_public_path__ + "static/ShewtaBapat.e2aeacb6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/mentImg/ShewtaBapat.jpg
// module id = 247
// module chunks = 25111403944408 251948199435738